export const UKSPA_CODES = [
  {
    key: 'productCode',
    displayValue: 'Product Code',
  },
  {
    key: 'description',
    displayValue: 'Description',
  },
];
